import { useTranslation } from 'react-i18next';
import {
    Chip,
} from '@material-ui/core';
import { Icon as MdiIcon } from '@mdi/react';
import { mdiShieldLockOpenOutline, mdiShieldLock } from '@mdi/js';
import './ProtectedStateIcon.scss';

/**
 * @param {{isProtected: boolean, size?: 'small' | 'medium'}} param0
 */
function ProtectedStateIcon({ isProtected, size = 'medium' }) {
    const { t } = useTranslation('shiftBidding', { keyPrefix: 'employee.bidAssignationShiftline.protectedState' });
    return (
        <Chip
            label={t(`${isProtected ? 'protected' : 'unprotected'}`)}
            size={size}
            avatar={(
                <MdiIcon
                    path={isProtected ? mdiShieldLock : mdiShieldLockOpenOutline}
                    size={1}
                    color={isProtected ? 'white' : '#616161'}
                />
            )}
            variant="outlined"
            className={`psi-chip-${isProtected ? 'protected' : 'unprotected'} ${size === 'small' && 'fit-content'}`}
        />
    );
}

export default ProtectedStateIcon;
